import { combineActions, handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import { mediaAssetDescriptionSuccess, updateMediaAssetSuccess } from './actions';

export default handleActions(
  {
    [mediaAssetDescriptionSuccess](state, { payload: { mediaAssetID, description } }) {
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          [mediaAssetID]: description,
        },
      };
    },
    [updateMediaAssetSuccess](state, { payload: { mediaAssetID, mediaAssetInfo } }) {
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          [mediaAssetID]: mediaAssetInfo?.description,
        },
      };
    },
    [combineActions(logoutSuccess)]() {
      return initialState;
    },
  },
  initialState
);
